/*
  Mamorigatana — enveloppe suivi ParcelPanel
  Injecte le shell Mamorigatana sur /apps/parcelpanel et applique les libellés FR.
*/
(function () {
  'use strict';

  var LABEL_MAP = {
    'Track Your Order': 'Suivi de commande',
    'Order Number': 'Numéro de commande',
    'Email or Phone Number': 'E-mail ou téléphone',
    'Or': 'Ou',
    'Tracking Number': 'Numéro de suivi',
    'Track': 'Suivre',
    'Order': 'Commande',
    'Shipment': 'Expédition',
    'Status': 'Statut',
    'Shipping To': 'Livraison à',
    'Current Location': 'Position actuelle',
    'Carrier': 'Transporteur',
    'Product': 'Produit',
    'Ordered': 'Commandé',
    'Order Ready': 'Commande prête',
    'Pending': 'En attente',
    'Info Received': 'Informations reçues',
    'In Transit': 'En transit',
    'Out for Delivery': 'En cours de livraison',
    'Ready for Pickup': 'Prêt à être retiré',
    'Delivered': 'Livré',
    'Exception': 'Exception',
    'Failed Attempt': 'Échec de livraison',
    'Expired': 'Expiré',
    'Estimated Delivery Date': 'Date de livraison estimée',
    'You may also like…': 'Vous pourriez aussi aimer…',
    'These items have not yet shipped.': 'Ces articles n\'ont pas encore été expédiés.',
    'Waiting for carrier to update tracking information, please try again later.':
      'En attente de mise à jour du transporteur, réessayez plus tard.',
  };

  function fixParcelPanelLayout(root) {
    var app = root || document.getElementById('pp-tracking-page-app');
    if (!app) return;

    app.style.setProperty('width', '100%', 'important');
    app.style.setProperty('max-width', '100%', 'important');

    app.querySelectorAll('.pp_tracking_content, .pp_tracking_form, .pp_tracking_form_div, input, button').forEach(function (el) {
      el.style.setProperty('max-width', '100%', 'important');
      el.style.removeProperty('left');
      el.style.removeProperty('right');
      if (el.tagName === 'INPUT') {
        el.style.setProperty('width', '100%', 'important');
        el.style.setProperty('display', 'block', 'important');
      }
      if (el.tagName === 'BUTTON') {
        el.style.removeProperty('transform');
      }
    });
  }

  function translateLabels(root) {
    if (!root) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;

    while ((node = walker.nextNode())) {
      var text = node.nodeValue;
      if (!text || !text.trim()) continue;

      var trimmed = text.trim();
      if (LABEL_MAP[trimmed]) {
        node.nodeValue = text.replace(trimmed, LABEL_MAP[trimmed]);
      }
    }

    root.querySelectorAll('button, label, span, p, h1, h2, h3, h4, th, td, option').forEach(function (el) {
      if (el.childNodes.length === 1 && el.childNodes[0].nodeType === Node.TEXT_NODE) {
        var value = el.textContent.trim();
        if (LABEL_MAP[value]) {
          el.textContent = LABEL_MAP[value];
        }
      }
    });
  }

  function injectShell() {
    var app = document.getElementById('pp-tracking-page-app');
    var main = document.getElementById('MainContent');
    var template = document.getElementById('mrg-tracking-shell-template');

    if (!app || !main) return false;

    if (main.querySelector('.mrg-tracking')) return true;

    var section = document.createElement('section');
    section.className = 'mrg-tracking';

    if (template) {
      section.innerHTML = template.innerHTML;
    } else {
      return false;
    }

    var widget = section.querySelector('.mrg-tracking__widget');
    if (!widget) return false;

    var placeholder = widget.querySelector('#pp-tracking-page-app');
    if (placeholder && placeholder !== app) {
      placeholder.remove();
    }

    if (app.parentElement !== widget) {
      widget.appendChild(app);
    }
    main.insertBefore(section, main.firstChild);
    document.body.classList.add('mrg-page-tracking');
    main.classList.add('mrg-tracking-main');

    if (window.mrgInitReveal) {
      window.mrgInitReveal(section);
    }

    return true;
  }

  function mountSectionPage() {
    var section = document.querySelector('.mrg-tracking');
    if (!section) return;

    document.body.classList.add('mrg-page-tracking');

    if (window.mrgInitReveal) {
      window.mrgInitReveal(section);
    }
  }

  function watchParcelPanel() {
    var app = document.getElementById('pp-tracking-page-app');
    if (!app) return;

    translateLabels(app);
    fixParcelPanelLayout(app);

    if (typeof MutationObserver !== 'function') return;

    var observer = new MutationObserver(function () {
      translateLabels(app);
      fixParcelPanelLayout(app);
    });

    observer.observe(app, {
      childList: true,
      subtree: true,
    });
  }

  function init() {
    var isAppProxy = document.getElementById('mrg-tracking-shell-template');
    var isSectionPage = document.querySelector('.mrg-tracking-section');

    if (isAppProxy) {
      injectShell();
    } else if (isSectionPage) {
      mountSectionPage();
    }

    watchParcelPanel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
